module.exports = __webpack_public_path__ + "static/media/google-play-social-media-svgrepo-com.ff404220.svg";